import type { OrderInterface, TransformedOrder } from '@/storage/orders'
import { ref } from 'vue'

export const selectedOrder = ref<TransformedOrder | TransformedOrder & { img: string } | undefined>(undefined)
